import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { RootState } from '../../../store/rootReducer'
import { RemoteConfigState } from './types'
import packageJson from '../../../../package.json'
import { PersistConfig } from 'redux-persist'

export const remoteConfigState: PersistConfig<RemoteConfigState> = {
  key: 'remoteConfig',
  storage: storage,
  version: 3,
}

export const remoteConfigInitialState: RemoteConfigState = {
  interval: 60,
  maintenance: false,
  maintenanceParams: {
    heading: 'We are currently under going maintenance',
    message:
      "FarmlandsPro is currently undergoing scheduled maintenance and will be back shortly. We apologise for any inconvenience. If you need assistance, please contact <a href='mailto:ask@farmlands.co.nz'>ask@farmlands.co.nz</a>",
  },
  version: packageJson.version,
  versionIsIgnored: true,
  seedEnabled: false,
  atomicEnabled: false,
  traderSpecialsEnabled: false,
  atomicPromotionsEnabled: false,
  quotePriceMin: 10000,
  quoteEnabled: true,
}

const RemoteConfigSlice = createSlice({
  name: 'remoteConfig',
  initialState: remoteConfigInitialState,
  reducers: {
    updateConfig(state: RemoteConfigState, { payload }: PayloadAction<RemoteConfigState>) {
      state = payload
    },

    updateKey(
      state: RemoteConfigState,
      { payload }: PayloadAction<{ key: string; value: string | number | boolean | object }>,
    ) {
      const { key, value } = payload
      // Check if the key exists in the expected state
      if (Object.prototype.hasOwnProperty.call(remoteConfigInitialState, key)) {
        if (!state[key]) {
          state[key] = value
          // Check if the type of the new value matches the type of the existing value
        } else if (typeof value === typeof state[key]) {
          state[key] = value
        } else {
          // If types don't match, throw an error or handle it accordingly
          console.error(
            new Error(`Type mismatch for key '${key}'. Expected type: ${typeof state[key]}.`),
          )
        }
      } else {
        // If the key doesn't exist, throw an error or handle it accordingly
        console.error(new Error(`Key '${key}' does not exist in state.`))
      }
    },
  },
})

const selectState = (state: RootState) => state

export const selectRemoteConfig = createSelector(
  selectState,
  (state): RemoteConfigState => state.remoteConfig,
)

// Define the function with generics
export const selectConfigByKey = <K extends keyof RemoteConfigState>(key: K) => {
  return createSelector(selectState, (state) => {
    return state.remoteConfig[key] as RemoteConfigState[K]
  })
}

export default RemoteConfigSlice
